import {computed, defineComponent, onMounted, reactive, ref, watch} from '@vue/composition-api';
import axios from "axios";
import {SettingsContext} from "@/utilities/settings-context";
import ForeignCompany from '@/components/foreign-company/foreign-company.vue';

import {getName} from "@/functions/authentication-functions";
import {createPageContext} from "@/components/navbar-box/page-context";
import {i18n} from "@/utilities/vue-i18n";

export default defineComponent({
    components: {
        ForeignCompany
    },
    props: {
        needsReload: String
    },
    setup(props, context) {

        const foreign = ref<{show: () => void}>();

        const add = async () => {

            const { redirectUrl } = await (await axios.get<{redirectUrl: string}>(SettingsContext.getApiUrl('RequestBankId'), { params: { returnUrl: `${location.origin}/assignment` }})).data;

            window.location.replace(redirectUrl);
        }

        const request = () => {

            foreign.value?.show();
        }

        const pageContext = createPageContext({
            title: {
                text: i18n.t('pages.home.title') as string
            },
            breadcrumb: {segments: [], showHome: false},
            actions: [
                {name: i18n.t('home.connect-company-sweden') as string, enabled: true, action: add},
                '-',
                {name: i18n.t('home.connect-company-non-sweden') as string, enabled: true, action: request}
            ]
        });

        return {

            pageContext,

            foreign
        };
    }
});
